import { useEffect, useMemo, useRef, useState } from "react";
import { useTranslation } from "../../../../../Translation";
import { ArrowDownIcon, ArrowsPointingOutIcon, ChevronDownIcon, Cog8ToothIcon, DocumentIcon, ExclamationCircleIcon, MinusIcon, PlusIcon, TableCellsIcon } from "@heroicons/react/24/outline";
import { webhook } from "../../../../../Resources/Images";
import { TextInput } from "../../../../Inputs/TextInput";
import { TextArea } from "../../../../Inputs/TextArea";
import { Button } from "../../../../Buttons";
import Tabs, { useTabs } from "../../../../Tabs";
import { useAPI } from "../../../../../API";
import Select from "../../../../Inputs/Select";
import { bgColor, hoverBgColor } from "../../../../../Resources/CSS/styling";
const ConfigurationTab = ({ tmpStep, setTmpStep, save, error, setError, isCreate, userApp, appWebhookStep, panelHook }) => {

    const { translate } = useTranslation();
    const api = useAPI();

    const [templateId, setTemplateId] = useState(tmpStep.data.template_id);
    const [to, setTo] = useState(tmpStep.data.to);
    const [multipleTo, setMultipleTo] = useState(tmpStep.data.multiple_to || []);
    const [showJsonImport, setShowJsonImport] = useState(false);
    const [didSort, setDidSort] = useState(false);
    const [jsonInput, setJsonInput] = useState('');
    const [keysOrder, setKeysOrder] = useState(() => Object.keys(tmpStep.data.dynamic_template_data || {}));

    useEffect(() => {
        if (tmpStep && tmpStep.data && !didSort) {
            const keys = Object.keys(tmpStep.data.dynamic_template_data || {}).sort((a, b) => a.localeCompare(b));
            setKeysOrder(keys);        
            setDidSort(true);
            console.log('sorted');
        }
        
    }, [tmpStep]);

    const sendgrid_api_key = userApp.data.api_key;
    const sendgrid_from = userApp.data.from_email;
    const sendgrid_from_name = userApp.data.from_name;

    const importJsonData = () => {
        try {
            const parsed = JSON.parse(jsonInput);
            if (typeof parsed !== 'object' || parsed === null || Array.isArray(parsed)) {
                setError('JSON must be an object with key-value pairs');
                return;
            }
            const stringifyValues = (obj) => {
                const result = {};
                for (const [key, value] of Object.entries(obj)) {
                    result[key] = (value !== null && typeof value === 'object')
                        ? JSON.stringify(value)
                        : value;
                }
                return result;
            };
            const newData = { ...tmpStep.data.dynamic_template_data, ...stringifyValues(parsed) };
            setKeysOrder(Object.keys(newData).sort((a, b) => a.localeCompare(b)));
            onDataChange(to, templateId, newData, multipleTo);
            setJsonInput('');
            setShowJsonImport(false);
            setError(null);
        } catch (e) {
            setError('Invalid JSON format');
        }
    };

    const addDynamicTemplateData = () => {
        var keyIndex = 0;
        while (keysOrder.some(k => k === `key_${keyIndex}`)) {
            keyIndex++;
        }

        if (!tmpStep.data.dynamic_template_data || typeof tmpStep.data.dynamic_template_data !== 'object') {
            tmpStep.data.dynamic_template_data = {};
        }

        const newKey = `key_${keyIndex}`;
        tmpStep.data.dynamic_template_data[newKey] = 'value';
        const newOrder = [...keysOrder, newKey].sort((a, b) => a.localeCompare(b));
        setKeysOrder(newOrder);
        onDataChange(to, templateId, tmpStep.data.dynamic_template_data, multipleTo);
    }

    const removeDynamicTemplateData = (key) => {
        delete tmpStep.data.dynamic_template_data[key];
        setKeysOrder(keysOrder.filter(k => k !== key));
        onDataChange(to, templateId, tmpStep.data.dynamic_template_data, multipleTo);
    }

    const dynamicTemplateData = useMemo(() => keysOrder.map(key => ({
        key: key,
        value: tmpStep.data.dynamic_template_data[key]
    })), [keysOrder, tmpStep]);

    const updateDynamicTemplateData = (key, updateKey, value) => {

        if (updateKey) {
            const keyIndex = keysOrder.indexOf(key);
            const oldValue = tmpStep.data.dynamic_template_data[key];
            delete tmpStep.data.dynamic_template_data[key];
            tmpStep.data.dynamic_template_data[value] = oldValue;
            const newOrder = [...keysOrder];
            newOrder[keyIndex] = value;
            setKeysOrder(newOrder);
        } else {
            tmpStep.data.dynamic_template_data[key] = value;
        }

        onDataChange(to, templateId, tmpStep.data.dynamic_template_data, multipleTo);
    }

    const addMultipleTo = () => {
        const newMultipleTo = [...multipleTo, { email: '' }];
        setMultipleTo(newMultipleTo);
        onDataChange(to, templateId, tmpStep.data.dynamic_template_data, newMultipleTo);
    }

    const removeMultipleTo = (index) => {
        const newMultipleTo = [...multipleTo];
        newMultipleTo.splice(index, 1);
        setMultipleTo(newMultipleTo);
        onDataChange(to, templateId, tmpStep.data.dynamic_template_data, newMultipleTo);
    }

    const updateMultipleTo = (index, email) => {
        const newMultipleTo = [...multipleTo];
        newMultipleTo[index].email = email;
        setMultipleTo(newMultipleTo);
        onDataChange(to, templateId, tmpStep.data.dynamic_template_data, newMultipleTo);
    }


    const onDataChange = (to, templateId, dynamic_template_data = {}, multipleTo = []) => {


        const from = { email: sendgrid_from };

        if (sendgrid_from_name) {
            from.name = sendgrid_from_name;
        }

        const apiCallBody = {
            "personalizations": [
                {
                    "to": [
                        {
                            "email": to
                        },
                        ...multipleTo.map(toIteration => ({
                            "email": toIteration.email
                        }))
                    ],
                    "dynamic_template_data": dynamic_template_data
                }
            ],
            "from": from,
            "template_id": templateId
        }


        const APICallStepData = {
            method: 'POST',
            url: 'https://api.sendgrid.com/v3/mail/send',
            body: apiCallBody,
            headers: {
                'Authorization': 'Bearer ' + sendgrid_api_key
            },
            to: to,
            template_id: templateId,
            dynamic_template_data: dynamic_template_data,
            multiple_to: multipleTo
        }

        console.log(APICallStepData);

        setTmpStep({ ...tmpStep, app_webhook_unique_identifier: appWebhookStep.webhook_unique_identifier, user_app_id: userApp.id, data: APICallStepData });
    }


    return (
        <div className="flex flex-col mt-4">

            {error && <p className="text-red-600 flex flex-row items-center bg-red-50 p-4"><ExclamationCircleIcon className="w-6 h-6 mr-2" />{error}</p>}
            <div className="flex flex-col mt-4">
                <div className="flex flex-row items-center justify-between">
                    <p className="text-xl text-gray-600 font-bold">{translate('automatisation.to_email')}</p>
                    <PlusIcon onClick={addMultipleTo} className="w-6 h-6 text-gray-600 cursor-pointer hover:text-gray-300" />
                </div>
                
                <TextInput value={to} onChange={(e) => {setTo(e.target.value); onDataChange(e.target.value, templateId, tmpStep.data.dynamic_template_data, multipleTo)}} />
                {multipleTo.map((toIteration, index) => (
                    <div className="flex flex-row w-full items-center">
                        <div className="flex flex-col w-full">
                            <TextInput value={toIteration.email} onChange={(e) => {updateMultipleTo(index, e.target.value)}} />
                        </div>
                        
                        <MinusIcon onClick={() => removeMultipleTo(index)} className="w-6 h-6 text-red-600 cursor-pointer ml-2 hover:text-red-300" />
                    </div>
                ))}
            </div>
            <div className="flex flex-col mt-4">
                <p className="text-xl text-gray-600 font-bold">{translate('automatisation.template_id')}</p>
                <TextInput value={templateId} onChange={(e) => {setTemplateId(e.target.value); onDataChange(to, e.target.value, tmpStep.data.dynamic_template_data, multipleTo)}} />
            </div>
            <div className="flex flex-row mt-4 items-center justify-between">
                <p className="text-xl text-gray-600 font-bold">{translate('automatisation.dynamic_template_data')}</p>
                <div className="flex flex-row items-center">
                    {!showJsonImport && (
                        <button onClick={() => setShowJsonImport(true)} className="text-xs text-gray-600 hover:text-gray-800 mr-2 underline">Import JSON</button>
                    )}
                    <PlusIcon onClick={addDynamicTemplateData} className="w-6 h-6 text-gray-600 cursor-pointer hover:text-gray-300" />
                </div>
            </div>
            {showJsonImport && (
                <div className="flex flex-col mt-4">
                    <div className="flex flex-row w-full">
                        <textarea
                            value={jsonInput}
                            onChange={(e) => setJsonInput(e.target.value)}
                            className="border rounded p-2 text-sm h-24 resize-none flex-1"
                            placeholder='{"name": "John", "city": "NYC"}'
                        />
                    </div>
                    <div className="flex flex-row justify-end mt-1">
                        <button onClick={() => setShowJsonImport(false)} className="text-xs text-gray-500 mr-2 hover:text-gray-700">Cancel</button>
                        <button onClick={importJsonData} className="text-xs bg-gray-800 text-white px-2 py-1 rounded hover:bg-gray-700">Import</button>
                    </div>
                </div>
            )}

            {dynamicTemplateData.map((data, index) => (
                <div className="flex flex-row w-full flex-1 items-center">
                    <div className="flex w-32">
                        <TextInput value={data.key} onChange={(e) => {
                            updateDynamicTemplateData(data.key, true, e.target.value);
                        }} />
                    </div>
                    <div className="flex flex-1 w-full flex-col ml-2">
                        <TextInput value={data.value} onChange={(e) => {
                            updateDynamicTemplateData(data.key, false, e.target.value);
                        }} />
                    </div>
                    <MinusIcon onClick={() => removeDynamicTemplateData(data.key)} className="w-6 h-6 text-red-600 cursor-pointer ml-2 hover:text-red-300" />
                </div>
            ))}

            {!isCreate && <div className="flex flex-row w-full flex-1 justify-end mt-4">
                <div className="flex flex-row">
                    <Button className="bg-black hover:bg-gray-800" onClick={() => save(tmpStep)}>
                        {translate('save')}
                    </Button>
                </div>
            </div>}
        </div>
    )
}

const DescriptionTab = ({ tmpStep, setTmpStep, save, isCreate }) => {
    const { translate } = useTranslation();
    return (
        <div className="flex flex-col mt-4">
            <p className="text-xl text-gray-600 font-bold">{translate('automatisation.description')}</p>
            <TextArea rows={5} value={tmpStep.description} onChange={(e) => setTmpStep({ ...tmpStep, description: e.target.value })} />

            {!isCreate && <div className="flex flex-row w-full flex-1 justify-end mt-4">
                <div className="flex flex-row">
                    <Button className="bg-black hover:bg-gray-800" onClick={() => save(tmpStep)}>
                        {translate('save')}
                    </Button>
                </div>
            </div>}
        </div>
    )
}

export default function SendGridEmailPanel({ setStepToClone, panelHook, step, refresh, deleteStep, isCreate, onCreateNewStep, app, appWebhookStep, userApp }) {
    const { translate } = useTranslation();
    const [isExpanded, setIsExpanded] = useState(false);
    const [tmpStep, setTmpStep] = useState({ ...step });
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);
    const api = useAPI();

    const tabs = useTabs([
        { icon: Cog8ToothIcon, name: translate('automatisation.configuration'), current: true },
        { icon: DocumentIcon, name: translate('automatisation.description'), current: false }
    ]);

    // Reset tmpStep when panel is closed
    useEffect(() => {
        if (!panelHook.open) {
            setTmpStep({ ...step });
        }
    }, [panelHook.open]);

    const save = async (tmpStep) => {


        try {

            const step = {
                ...tmpStep,
                data: {
                    ...tmpStep.data,
                    headers: tmpStep.data.headers,
                    url: tmpStep.data.url,
                    method: tmpStep.data.method,
                    body: tmpStep.data.body
                }
            }

            if (isCreate) {
                try {
                    if (!step.description || step.description.trim() === '') {
                        step.description = "Send email from SendGrid";
                    }

                    const newStepResponse = await api.createAutomatisationStep(tmpStep.automatisation_id, step);
                    if (newStepResponse?.data?.automatisation_step) {
                        await onCreateNewStep(newStepResponse.data.automatisation_step);
                    }
                } catch (e) {}
                
            } else {
                await api.updateAutomatisationStep(tmpStep.automatisation_id, step);
            }

            panelHook.setOpen(false);
            setTimeout(() => {
                refresh();
            }, 1000);
        } catch (e) {
            setError('Invalid JSON');
            return;
        }

    }

    const selectStepToClone = (step) => {
        setStepToClone(step);
        panelHook.setOpen(false);
    }


    return (
        <div className="flex flex-col flex-1 h-min rounded-md p-4 bg-white overflow-hidden">
            <div className="flex flex-row items-center">
                <img src={app?.icon} alt="webhook" className="w-12 h-12 min-w-12 min-h-12 aspect-square border p-2 bg-gray-50 rounded-md cursor-pointer object-contain mr-2 text-black" />
                <h2 className="text-xl font-bold">{app?.name}</h2>
                <div className="flex flex-row flex-1 justify-end">

                {!isCreate && <Button className="bg-red-600 hover:bg-red-300 ml-4" onClick={deleteStep}>
                        {translate('delete')}
                    </Button>}
                {isCreate && <Button className={`${bgColor} ${hoverBgColor} ml-4 opacity-100`} onClick={() => save(tmpStep)}>{translate('create')}</Button>}
                {!isCreate && <Button className={`${bgColor} ${hoverBgColor} ml-4 opacity-100`} onClick={() => selectStepToClone(tmpStep)}>{translate('clone')}</Button>}
                </div>
            </div>

            <div className="flex flex-row overflow-x-scroll no-scrollbar">
                <Tabs tabs={tabs} />
            </div>

            {tabs.currentTabIndex === 0 && <ConfigurationTab tmpStep={tmpStep} setTmpStep={setTmpStep} panelHook={panelHook} error={error} setError={setError} save={save} isCreate={isCreate} userApp={userApp} appWebhookStep={appWebhookStep} />}
            {tabs.currentTabIndex === 1 && <DescriptionTab tmpStep={tmpStep} setTmpStep={setTmpStep} panelHook={panelHook} error={error} save={save} isCreate={isCreate} />}
        </div>
    )
}